<div class="bg-[#f7f9ff] min-h-screen">
  @if (pageIsLoading()) {
    <mat-progress-bar mode="indeterminate" value="50" color="primary"></mat-progress-bar>
  } @else {
    <div class="py-200-rem px-250-rem h-full" data-testid="firmware-details">
      <remote-update-domain-app-page-wrapper
        [data]="null"
        [hasError]="firmwareDetailsHasError()"
        [emptyTitle]="emptyFirmwarePackageTitle"
        [emptyDescription]="emptyFirmwarePackageDescription"
        [isLoading]="pageIsLoading()"
        [height]="height">
        <div content>
          <div class="flex justify-between space-y-050-rem">
            <h1 class="text-[1.5rem] text-[#292F32] w-full font-semibold">
              Firmware package detail view (state: {{ packageDetails().packageStatus }})
            </h1>
            <div class="grid mt-050-em cursor-pointer">
              @if (packageDetails().packageStatus === 'Draft') {
                <div class="flex space-x-150-em">
                  <button matButton="outlined" (click)="confirmDeleteFirmwarePackage()">Delete</button>
                  <button matButton="outlined" (click)="editFirmwarePackage()">Edit</button>
                  <button mat-flat-button (click)="confirmReleaseFirmwarePackage()">Release</button>
                </div>
              } @else if (packageDetails().packageStatus === 'Released') {
                <button mat-flat-button (click)="confirmWithdrawFirmwarePackage()">Withdraw</button>
              }
            </div>
          </div>
          <div
            class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-2 flex flex-col">
            <h1 class="text-headline-sm-weight-medium text-container-fg-default">File upload</h1>

            <div>
              <div class="flex items-center justify-between mt-075-rem">
                <div class="flex items-center gap-075-rem">
                  <div>
                    <img src="/svgs/file-icon.svg" alt="file" />
                  </div>
                  <div class="flex flex-col">
                    <span class="truncate block max-w-50"
                      >{{packageDetails().fileUpload.fileName}}</span
                      >
                      <span class="text-gray-500"
                        >{{ packageDetails().fileUpload.fileSize | number }} bytes</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-2 flex flex-col">
                <h1 class="text-headline-sm-weight-medium text-container-fg-default">
                  Manifest information
                </h1>
                <div class="-mr-100-rem">
                  <div [innerHTML]="extractedXmlContent()"></div>
                </div>
              </div>

              <div
                class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-6 flex flex-col">
                <h1 class="text-headline-sm-weight-medium text-container-fg-default">Package metadata</h1>
                <div class="space-y-3">
                  <div>
                    <h3 class="text-label-lg-weight-medium text-container-fg-default">Package name</h3>
                    <p class="text-body-lg-weight-regular text-container-fg-default firmware-details-description">
                      {{ packageDetails().packageMetadata.packageName }}
                    </p>
                  </div>

                  <div>
                    <h3 class="text-label-lg-weight-medium text-container-fg-default">Update class</h3>
                    <mat-radio-group
                      aria-label="update classification"
                      class="grid pt-025-rem"
                      [disabled]="true"
                      [value]="packageDetails().packageMetadata.classification">
                      <mat-radio-button value="Critical update">Critical update</mat-radio-button>
                      <mat-radio-button value="Major update">Major update</mat-radio-button>
                      <mat-radio-button value="Minor update">Minor update</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <div
                class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-2 flex flex-col">
                <h1 class="text-headline-sm-weight-medium text-container-fg-default">
                  Device Compatibility
                </h1>

                <div class="flex flex-col gap-150-em justify-start">
                  @for (versions of packageDetails().deviceCompatibility.compatible_device_software_versions; track versions; let i = $index) {
                    <div
                      class="flex items-center gap-100-em"
                      >
                      <div class="text-body-md-weight-regular text-container-fg-muted">CP</div>
                      <div>
                        <p class="text-label-sm-weight-regular text-container-fg-muted">
                          Compatible device software versions
                        </p>
                        <p class="text-body-lg-weight-regular text-container-fg-default">{{versions}}</p>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div
                class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-6 flex flex-col">
                <h1 class="text-headline-sm-weight-medium text-container-fg-default text-[1.125rem]">
                  Distribution
                </h1>

                <form class="space-y-100-rem">
                  <p class="text-label-lg-weight-medium">Allowed to install by</p>
                  <div class="opacity-45">
                    <mat-button-toggle-group
                      name="mat-button-toggle-group"
                      aria-label="access"
                      [disabled]="true"
                      [value]="packageDetails().distribution.access">
                      <mat-button-toggle value="Update by CPO">Update by CPO</mat-button-toggle>
                      <mat-button-toggle value="Update by CPO & end-user"
                        >Update by CPO & user</mat-button-toggle
                        >
                      </mat-button-toggle-group>
                    </div>

                    <div>
                      <p class="text-label-lg-weight-medium">Installable via</p>

                      @for(companionAppDetails of packageDetails().distribution.supportedCompanionApps;
                        track companionAppDetails.name){
                        <div class="grid grid-cols-3 space-y-150-rem">
                          <mat-checkbox [checked]="companionAppDetails.name.length > 0" [disabled]="true">
                            {{ companionAppDetails.name }}
                          </mat-checkbox>
                          <div>
                            <p class="text-label-sm-weight-regular text-container-fg-muted">
                              iOS minimum version
                            </p>
                            <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
                              {{ companionAppDetails.appleMinimumVersion }}
                            </p>
                          </div>

                          <div>
                            <p class="text-label-sm-weight-regular text-container-fg-muted">
                              Android minimum version
                            </p>
                            <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
                              {{ companionAppDetails.androidMinimumVersion }}
                            </p>
                          </div>
                        </div>
                      }
                    </div>
                  </form>
                </div>

                <div
                  class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container flex flex-col">
                  <h1 class="text-headline-sm-weight-medium text-container-fg-default">Release notes</h1>
                  <h3 class="text-label-lg-weight-medium text-container-fg-default py-100-rem">
                    JSON input
                  </h3>
                  <p class="release-notes-content text-container-fg-disabled whitespace-pre-wrap">
                    {{packageDetails().releaseNotes | json }}
                  </p>
                </div>
              </div>
            </remote-update-domain-app-page-wrapper>
            <div class="py-150-rem mt-050-rem changeTable gap-6 flex flex-col">
              <h1
                class="text-headline-sm-weight-medium text-container-fg-default ml-200-rem mb-050-rem text-[1.125rem]">
                Change history
              </h1>

              <remote-update-domain-app-page-wrapper
                [data]="packageChangeHistory()"
                [hasError]="packageHistoryHasError()"
                [emptyTitle]="emptyChangeHistoryTitle"
                [emptyDescription]="emptyChangeHistoryDescription"
                [isLoading]="pageIsLoading()"
                [height]="height">
                <div content>
                  <remote-update-feature-remote-update-dashboard-change-history-table
                  [data]="packageChangeHistory()"></remote-update-feature-remote-update-dashboard-change-history-table>
                </div>
              </remote-update-domain-app-page-wrapper>
            </div>
          </div>
        }
      </div>
